<form [formGroup]="form" class="example-form">
  <!-- First Section: Kanban and Part Number -->
  <div *ngIf="currentSection === 1" class="d-flex flex-column hcm-custom-screen">
    <mat-card class="p-3 hcm-shadow-card">
      <!-- <div class="alert alert-danger" role="alert" *ngIf="errorList.length > 0">
        <span *ngFor="let error of errorList">{{error}}</span><br />
      </div> -->
      <div class="alert alert-success" role="alert" *ngIf="successList.length">
        <span *ngFor="let x of successList">{{x}}</span><br />
      </div>
      <div class="row">
        <div class="d-flex justify-content-start align-items-center material-button-mobile d-lg-none">
          <div class="scan-box-owk d-flex justify-content-center align-items-center">
            <img src="../../../../../assets/img/scan-icon.png" alt="HCM Scan">
            <button mat-button class="btn" (click)="onScanOWKButtonClick()">
              <span class="hcm-error-msg">{{ 'vehicleInfo.scanButtons.scanOwk' | translate }}</span>
            </button>
            <div *ngIf="scanErrorMessage" class="alert hcm-error-msg">
              {{ scanErrorMessage }}
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12 col-md-4">
          <div class="w-100 flex flex-column">
            <div class="hcm-label mb-1">KANBAN<span class="hcm-mandatory ms-2">*</span></div>
            <input class="rounded border p-2 hcm-value w-100 shadow-input placeHolderColor"
              (input)="onKanbanInputChange()" formControlName="kanban" maxlength="4" placeholder="KANBAN" required>
            <mat-error class="hcm-error-msg"
              *ngIf="form.get('kanban')?.hasError('required') && form.get('kanban')?.touched">
              {{ 'vehicleInfo.errors.pleaseEnterKanban' | translate }}
            </mat-error>
            <small class="col-12 hcm-error-msg"
              *ngIf="form.get('kanban')?.hasError('invalid') && form.get('kanban')?.touched">
              {{ form.get('kanban')?.errors?.invalid }}
            </small>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12 col-md-4">
          <div class="w-100 flex flex-column">
            <div class="hcm-label mb-1">{{ 'vehicleInfo.labels.partNumber' | translate }}<span
                class="hcm-mandatory ms-2">*</span> </div>
            <input class="rounded border p-2 hcm-value w-100 shadow-input placeHolderColor"
              (input)="onPartNumberInputChange()" formControlName="partnumber" maxlength="12"
              placeholder="{{ 'vehicleInfo.labels.partNumber' | translate }}">
            <mat-error class="hcm-error-msg"
              *ngIf="form.get('partnumber')?.hasError('required') && form.get('partnumber')?.touched">
              {{ 'vehicleInfo.errors.pleaseEnterpartnumber' | translate }}
            </mat-error>
          </div>
        </div>
      </div>
      <div class="row mt-3 d-flex flex-wrap flex-md-column">
        <div class="col-6 col-md-4">
          <div class="hcm-label mb-1">

            {{ 'vehicleInfo.labels.supplier' | translate }}
          </div>
          <input class="p-2 rounded border hcm-value w-100 shadow-input hcm-disable-input-box"
            formControlName="supplier" disabled />
          <mat-error class="hcm-error-msg"
            *ngIf="form.get('kanban')?.hasError('required') && form.get('supplier')?.touched">

            {{ 'vehicleInfo.errors.required' | translate }}
          </mat-error>
        </div>
        <div class="col-6 col-md-4 mt-md-3">
          <div class="hcm-label mb-1">

            {{ 'vehicleInfo.labels.dock' | translate }}
          </div>
          <ng-container *ngIf="options?.length > 1; else textDockBox">
            <mat-select [ngClass]="{ 'highlight-dock-border': options?.length > 1 }" placeholder="Select Dock"
              formControlName="dock" class="p-2 shadow-input hcm-value rounded border w-100"
              [(ngModel)]="selectedValue">
              <mat-option *ngFor="let option of options" [value]="option">

                {{ option }}
              </mat-option>
            </mat-select>
          </ng-container>
          <ng-template #textDockBox>
            <input class="p-2 rounded border hcm-value w-100 shadow-input hcm-disable-input-box" formControlName="dock"
              disabled />
          </ng-template>
          <mat-error class="hcm-error-msg"
            *ngIf="form.get('kanban')?.hasError('required') && form.get('dock')?.touched">

            {{ 'vehicleInfo.errors.required' | translate }}
          </mat-error>
        </div>
      </div>


      <div class="row mt-3">
        <div class="col-12 col-md-4">
          <div class="hcm-label mb-1">{{ 'vehicleInfo.labels.deliveryAddress' | translate }}</div>
          <div class="col-12">
            <ng-container *ngIf="deliveryDropdown ; else textDelAddrBox">
              <mat-select class="w-100 highlight-dock-border" [(ngModel)]="selectedValue" placeholder="Select Address"
                formControlName="deliveryAddress">
                <mat-option *ngFor="let option of deliveryoptions" [value]="option">
                  {{ option }}
                </mat-option>
              </mat-select>
            </ng-container>
            <ng-template #textDelAddrBox>
              <input class="p-2 rounded border hcm-value w-100 shadow-input hcm-disable-input-box"
                formControlName="deliveryAddress" disabled />

            </ng-template>
            <mat-error class="hcm-error-msg"
              *ngIf="form.get('kanban')?.hasError('required') && form.get('deliveryAddress')?.touched">
              {{ 'vehicleInfo.errors.required' | translate }}
            </mat-error>
          </div>

        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12 col-md-4">
          <div class="hcm-label mb-1">
            {{ 'vehicleInfo.labels.storeAddress' | translate }}</div>
          <input class="p-2 rounded border hcm-value w-100 shadow-input hcm-disable-input-box"
            formControlName="storeAddress" disabled />

          <mat-error class="hcm-error-msg"
            *ngIf="form.get('kanban')?.hasError('required') && form.get('storeAddress')?.touched">
            {{ 'vehicleInfo.errors.required' | translate }}
          </mat-error>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12 col-md-4">
          <div class="hcm-label mb-1">{{ 'vehicleInfo.labels.quantityPresent' | translate }}:<span
              class="hcm-mandatory ms-2">*</span></div>
          <div class="d-flex align-items-center gap-3">
            <div class="form-check form-check-inline">
              <input class="form-check-input hcm-custom-radio" type="radio" name="quantityType" value="1"
                formControlName="quantityType" id="piecesOption">
              <label class="form-check-label text-center mb-1" for="piecesOption">
                {{ 'vehicleInfo.labels.quantityOptions.pieces' | translate }}
              </label>
            </div>

            <div class="form-check form-check-inline">
              <input class="form-check-input hcm-custom-radio" type="radio" name="quantityType" value="2"
                formControlName="quantityType" id="percentageOption">
              <label class="form-check-label text-center mb-1" for="percentageOption">
                {{ 'vehicleInfo.labels.quantityOptions.percentage' | translate }}
              </label>
            </div>
          </div>
          <div class="col-12" *ngIf="form.get('quantityType').value === '1'">
            <input class="p-2 rounded border p-2 hcm-value w-100 shadow-input" formControlName="quantityOfBox"
              type="number" />
          </div>
          <div class="col-12" *ngIf="form.get('quantityType').value === '2'">
            <mat-select class="p-2 rounded border p-2 hcm value w-100" formControlName="percentageOfBox"
              [placeholder]="'vehicleInfo.labels.quantityInputs.selectPercentage' | translate">
              <mat-option *ngFor="let percent of percentages" [value]="percent">
                {{ percent }}
              </mat-option>
            </mat-select>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12 col-md-4">
          <div class="hcm-label mb-1">
            {{ 'vehicleInfo.labels.partQpc' | translate }} </div>
          <input class="p-2 rounded border hcm-value w-100 shadow-input hcm-disable-input-box" formControlName="partQpc"
            disabled />
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12 col-md-4">
          <div class="col-12 flex flex-column">
            <div class="hcm-label mb-1">{{ 'vehicleInfo.labels.fullBoxes' | translate }}</div>
            <input class="p-2 rounded border p-2 hcm-value w-100 shadow-input" formControlName="numberOfFullBoxes"
              type="number">
          </div>
        </div>
      </div>
    </mat-card>
  </div>
  <footer class="mt-auto" *ngIf="currentSection === 1">
    <div class="row">
      <div class="d-flex justify-content-between justify-content-md-end p-2 mt-4 gap-2 footer-blue">
        <button class="hcm-blue-btn" (click)="onCancel()">
          <a>{{ 'vehicleInfo.buttons.cancel' | translate }}</a>
        </button>
        <button class="hcm-black-btn" (click)="navigateToInventory()">
          <span>{{ 'vehicleInfo.buttons.enterVehicleInfo' | translate }}</span>
          <span class="ms-2 mb-1 justify-content-center">
            <img src="../../../../../assets/img/arrow.svg" />
          </span>
        </button>
      </div>
    </div>
  </footer>
  <!-- second Section -->
  <div *ngIf="currentSection === 2" class="d-flex flex-column hcm-custom-screen">
    <mat-card class="p-3 hcm-shadow-card">
      <div class="alert alert-success" role="alert" *ngIf="successList.length">
        <span *ngFor="let x of successList">{{x}}</span><br />
      </div>
      <div class="hcm-warn-message p-2" *ngIf="isDuplicateTicket">
        <span class="hcm-warn-message-text">{{ 'vehicleInfo.errors.duplicateTicketPrefix' | translate }}</span>
        <span class="hcm-warn-message-hpr-link ms-2"
          (click)="onUpdatePopUp(duplicateTicketId)">{{duplicateTicketId}}</span>
        <span class="hcm-warn-message-text ms-2">{{ 'vehicleInfo.errors.duplicateTicketSuffix' | translate
          }}({{runOutData?.kanbanCode}})</span>
      </div>
      <div class="d-flex justify-content-start align-items-center material-button-mobile d-lg-none">
        <div class="scan-box d-flex justify-content-center align-items-center">
          <img src="../../../../../assets/img/scan-icon.png" alt="HCM Scan">
          <button mat-button class="btn" (click)="onScanOWKButtonClick()">
            <span class="hcm-error-msg">{{ 'vehicleInfo.scanButtons.scanManifest' | translate }}</span>
          </button>
          <div *ngIf="scanErrorMessage" class="alert hcm-error-msg">
            {{ scanErrorMessage }}
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12 col-md-4" *ngIf="!isShopWithNoSequenceNumber()">
          <div class="col-12">
            <p class="hcm-label mb-1">{{ 'vehicleInfo.labels.sequenceNumber' | translate }}
              <span class="hcm-mandatory">*</span>
            </p>
            <input #autoFocusSeqNbr class="p-2 rounded border hcm-value w-100 shadow-input" type="text"
              formControlName="sequenceNumber" required pattern="^\d{1,3}$" maxlength="3"
              (blur)="formatSequenceNumber()" (keypress)="numberOnly($event)" (input)="onSequenceInputChange()">
            <mat-error class="hcm-error-msg"
              *ngIf="form.get('sequenceNumber')?.hasError('required') && form.get('sequenceNumber')?.touched">
              {{ 'vehicleInfo.errors.pleaseEnterSeq' | translate }}
            </mat-error>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12 col-md-4">
          <div class="col-12">
            <p class="hcm-label mb-1">{{ 'vehicleInfo.labels.bodyNumber' | translate }}
              <span class="hcm-mandatory">*</span>
            </p>
            <input class="p-2 rounded border hcm-value w-100 shadow-input" type="text" formControlName="bodyNumber"
              required pattern="^\d{1,5}$" maxlength="5" (blur)="formatBodyNumber()" (keypress)="numberOnly($event)"
              (input)="onBodyNumberInputChange()">
            <mat-error class="hcm-error-msg"
              *ngIf="form.get('bodyNumber')?.hasError('required') && form.get('bodyNumber')?.touched">
              {{ 'vehicleInfo.errors.pleaseEnterBody' | translate }}
            </mat-error>
          </div>
        </div>
        <div class="col-12 mt-3">
          <div class="col-12">
            <p class="hcm-label mb-1">{{ 'vehicleInfo.labels.lineside_comments' | translate }}</p>
            <textarea class="p-2 rounded border hcm-value w-100 shadow-input" rows="3"
              formControlName="lineSideComments" maxlength="128"></textarea>
          </div>
        </div>
      </div>
    </mat-card>
    <footer class="mt-auto" *ngIf="currentSection === 2">
      <div class="row">
        <div class="d-flex justify-content-between footer-blue p-2 mt-4">
          <div class="d-flex justify-content-center">
            <button class="hcm-back-btn" (click)="goBack()">
              <img src="../../../assets/img/navigation_blue.svg" alt="back" class="me-1">
              {{ 'vehicleInfo.buttons.back' | translate }}
            </button>
          </div>
          <div class="d-flex justify-content-end gap-2">
            <button class="hcm-blue-btn" (click)="onCancel()">
              {{ 'vehicleInfo.buttons.cancel' | translate }}
            </button>
            <button class="hcm-black-btn" (click)="navigateToInquiry()">
              <span>{{ 'vehicleInfo.buttons.inquire' | translate }}</span>
              <span class="ms-2 mb-1 justify-content-center">
                <img src="../../../../../assets/img/arrow.svg" />
              </span>
            </button>
          </div>
        </div>
      </div>
    </footer>
  </div>
  <!-- third Section-->
  <div *ngIf="currentSection === 3" class="d-flex flex-column hcm-custom-screen">
    <div class="hcm-shadow-card">
      <div class="alert alert-success" role="alert" *ngIf="successList.length">
        <span *ngFor="let x of successList">{{x}}</span><br />
      </div>
      <div class="d-flex align-items-start p-md-3 p-2 gap-md-5 gap-3">
        <span class="hcm-ticket-Id">{{hotCallTicket}}</span>
        <div class="d-flex flex-column">
          <span> <button class="hcm-status-btn rounded-pill">
              {{ 'vehicleInfo.buttons.potentialShortage' | translate }}
            </button></span>
          <span class="hcm-label px-1"> Inquired at : {{currentTime}}</span>
        </div>
      </div>
      <!-- <div *ngIf="isErrorMessageVisible" class="alert alert-danger w-100 mt-3">
        {{ 'vehicleInfo.errors.runOutError' | translate }}
      </div> -->
      <div class="border-top my-3 d-lg-none"></div>
      <div class="col-6 col-md-3 col-lg-3 col-sm-4 ms-3 mb-3">
        <div class="p-1 col-md-12 attach-image-border">
          <div class="d-flex align-items-center justify-content-start mt-2 ms-2">
            <button (click)="fileInput.click()" aria-label="Upload Image" class="hcm-upload-icon p-0 border-0">
              <div class="hcm-attach-icon plus-sign">+</div>
            </button>
            <label for="fileInput" class="hcm-value mb-0 ms-2 d-block d-sm-inline">{{ 'vehicleInfo.labels.attachImage' |
              translate
              }}</label>
            <input #fileInput id="fileInput" matInput type="file" hidden />
          </div>
        </div>
      </div>
      <div class="row px-4">
        <div class="col-6">
          <div class="hcm-label mb-1">{{ 'vehicleInfo.labels.supplier' | translate }}<br>
            <span class="hcm-value">{{runOutData?.supplierCode}}</span>
          </div>
        </div>
        <div class="col-6">
          <div class="hcm-label mb-1">{{ 'vehicleInfo.labels.dock' | translate }}<br>
            <span class="hcm-value">{{runOutData?.dockCode }}</span>
          </div>
        </div>
      </div>
      <div class="row px-4">
        <div class="col-6">
          <div class="hcm-label mb-1">{{ 'vehicleInfo.labels.kanban' | translate }}<br>
            <span class="hcm-value">{{runOutData?.kanbanCode }}</span>
          </div>
        </div>
        <div class="col-6">
          <div class="hcm-label mb-1">{{ 'vehicleInfo.labels.partNumber' | translate }}<br>
            <span class="hcm-value">{{runOutData?.partNumber }}</span>
          </div>
        </div>
      </div>
      <div class="row px-4">
        <div class="col-6">
          <div class="hcm-label mb-1">{{ 'vehicleInfo.labels.linesideAddress' | translate }}<br>
            <span class="hcm-value">{{runOutData?.linesideAddress }}</span>
          </div>
        </div>
        <div class="col-6">
          <div class="hcm-label mb-1">{{ 'vehicleInfo.labels.currentVehicleSeq' | translate }}<br>
            <span class="hcm-value">{{runOutData?.currentVehicleSeq}}</span>
          </div>
        </div>
      </div>
      <div class="hot-call-box-border pt-2">
        <div class="row px-3">
          <div class="col-md-6">
            <div class="hcm-label mb-1">{{ 'vehicleInfo.labels.piecesRemaining' | translate }}<br>
              <span class="hcm-value">{{runOutData?.piecesRemaining }}</span>
            </div>
          </div>
          <div class="col-6">
            <div class="hcm-label mb-1">{{ 'vehicleInfo.labels.vehiclesToEmpty' | translate }}<br>
              <span class="hcm-value">{{runOutData?.vehiclesToEmpty }}</span>
            </div>
          </div>
        </div>
        <div class="row px-3">
          <div class="col-md-6">
            <div class="hcm-label mb-1">{{ 'vehicleInfo.labels.firstVehicleSeq' | translate }}<br>
              <span class="hcm-value">{{runOutData?.firstMissedPartSeqNo }}</span>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="hcm-label mb-1">{{ 'vehicleInfo.labels.firstVehicleBody' | translate }}<br>
              <span class="hcm-value">{{runOutData?.firstMissedPartBodyNo }}</span>
            </div>
          </div>
        </div>
        <div class="row px-3">
          <div class="col-6">
            <div class="hcm-label p-0 mb-1">{{ 'vehicleInfo.labels.trackingPoint' | translate }}<br>
              <span class="hcm-value">{{runOutData?.tpCount }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row px-4 pt-3">
        <div class="col-12">
          <div class="hcm-label mb-1">{{ 'vehicleInfo.labels.linesideComments' | translate }}<br>
            <span class="hcm-value">{{runOutData?.lineSideComments }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <footer class="mt-auto" *ngIf="currentSection === 3">
    <div class="row">
      <div class=" p-2 mt-4 d-flex justify-content-between justify-content-md-end footer-blue gap-2">
        <!-- Cancel Button (left on mobile, right on web) -->
        <button class="hcm-blue-btn" (click)="onCancel()"><a>{{ 'vehicleInfo.buttons.cancel' | translate }}</a></button>

        <!-- Submit Button (right on mobile, right on web) -->
        <button *ngIf="!disableSubmit" class="hcm-red-btn" (click)="onHotCallSubmit('Submit')">
          <span>{{ 'runoutInfo.buttons.submitHotCall' | translate }}</span>
        </button>
      </div>
    </div>
  </footer>
</form>